<template>
  <div class="caseDetail">
    <el-dialog
      v-model="curDialogVisible"
      center
      :show-close="false"
      :close-on-click-modal="false"
      @closed="escClose"
    >
      <div class="bg">
        <div class="top-box">
          <div class="title"> {{model?.testCase}}</div>
          <div class="right-box">
            <img class="img1" src="@/assets/next-icon.png" @click="nextDo"/>
            <img class="img2" src="@/assets/previous-icon.png" @click="previousDo"/>
            <img class="img3" src="@/assets/packup-icon.png" @click="closeDo"/>
          </div>
        </div>
        <div class="line"></div>
        <div v-if="isCompare">
          <div class="version-box box">
            <div class="version1-title">{{ model?.tool?.leftTool}}</div>
            <div class="version2-title">{{ model?.tool?.rightTool}}</div>
            <div class="com-title">Ratios</div>
          </div>
          <div class="content-box">
            <MoreVersionItem v-for="(title, index) in headers" :key="index" :title="title" :model="model[title]"></MoreVersionItem>
          </div>
        </div>
        <div v-else>
          <div class="version-box">{{ model?.tool?.leftTool}}</div>
          <div class="content-box">
            <SingleVersionItem v-for="(title, index) in headers" :key="index" :title="title" :value="model[title]"></SingleVersionItem>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SingleVersionItem from "@/components/SingleVersionItem.vue";
import MoreVersionItem from "@/components/MoreVersionItem.vue";

export default {
  name: "caseDetail",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isCompare: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    dialogVisible(val) {
      this.curDialogVisible = val;
    },
  },
  data() {
    return {
      curDialogVisible: false,
    };
  },
  computed: {
    
  },
  methods: {
    nextDo() {
      console.log("next do ....")
      this.$emit("nextDo")
    },
    previousDo() {
      console.log("previous do ....")
      this.$emit("previousDo")
    },
    closeDo() {
      this.$emit("closeDo")
    },
    escClose() {
      this.$emit("closeDo")
    }
  },
  created() {},
  components: {
    SingleVersionItem,
    MoreVersionItem
  },
};
</script>
<style lang='less' scoped>
.caseDetail {
  height: 100%;
  width: 100%;
}
.bg {
  height: 100%;
  width: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  margin: auto;
}

.top-box {
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-content: space-between;
  align-items: center;

  .title {
    color: #000000;
    font-size: 24px;
    font-weight: bold;
  }

  .right-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .img1 {
      height: 15px;
      width: 15px;
      object-fit: contain;
      margin-right: 10px;
      cursor: pointer;
    }
    .img2 {
      height: 15px;
      width: 15px;
      object-fit: contain;
      margin-right: 10px;
      cursor: pointer;
    }
    .img3 {
      height: 20px;
      width: 20px;
      object-fit: contain;
      cursor: pointer;
    }
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #c7c7c7;
  margin-top: 10px;
}

.version-box {
  margin-top: 20px;
  font-size: 14px;
  color: #0050b3;
  font-weight: 500;
}

.box {
  display: flex;
  flex-direction: row;

  .version1-title {
    width: 160px;
  }
  .version2-title {
    width: 160px;
    margin-left: 15px;
  }
  .com-title {
    width: 80px;
    margin-left: 30px;
  }
}

.content-box {
  margin-top: 20px;
  width: 100%;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: auto;
}

:deep(.el-dialog) {
  border-radius: 8px;
  height: 700px !important;
  width: 600px !important;
}
</style>